import React, { useState } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import firebase from "../../firebase";
import "./nabar.css";

const NAVIE = () => {
  const [expanded, setExpanded] = useState(false);

  const handleLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        console.log("Logout successful");
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };

  const handleLinkClick = () => {
    setExpanded(false); // Close the menu on link click
  };

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
      expanded={expanded} // Control the expanded state
    >
      <Container>
        {/* Logo Section */}
        <Navbar.Brand className="d-flex align-items-center">
          <Link to="/" className="d-flex align-items-center">
            <img
              src=".\assets\img\logo.png"
              width="50"
              height="50"
              className="d-inline-block align-top"
              alt="financeFrenzy"
            />
            <div className="ms-2">
              <span
                className="brand"
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                financeFrenzy
              </span>
              <div
                style={{
                  fontSize: "0.8rem",
                  color: "lightgray",
                }}
              >
                We help build your DREAM!
              </div>
            </div>
          </Link>
        </Navbar.Brand>

        {/* Toggle Button */}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="ms-auto"
          onClick={() => setExpanded(expanded ? false : true)} // Toggle menu state
        />

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link className="me-3" onClick={handleLinkClick}>
              <Link className="nav-link" to="/About">
                <h5>About</h5>
              </Link>
            </Nav.Link>
            <Nav.Link className="me-3" onClick={handleLinkClick}>
              <Link className="nav-link" to="/Services">
                <h5>Services</h5>
              </Link>
            </Nav.Link>
            <Nav.Link className="me-3" onClick={handleLinkClick}>
              <Link className="nav-link" to="/Products">
                <h5>Products</h5>
              </Link>
            </Nav.Link>
            <Nav.Link className="me-3" onClick={handleLinkClick}>
              <Link className="nav-link" to="/Careers">
                <h5>Careers</h5>
              </Link>
            </Nav.Link>
            <Nav.Link className="me-3" onClick={handleLinkClick}>
              <Link className="nav-link" to="/Contact">
                <h5>Contact</h5>
              </Link>
            </Nav.Link>
            <Nav.Link className="me-3" onClick={handleLinkClick}>
              <Link className="nav-link" to="/faqs">
                <h5>FAQ</h5>
              </Link>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NAVIE;
